import { Box } from '@hivebrite/design-system/Box';
import { Card as DSCard } from '@hivebrite/design-system/Card';
import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';

import { Calendar } from 'hb-react/shared/apps/Events/components/Calendar';
import { EventWebinarUrl } from 'hb-react/shared/apps/Events/components/EventDetailsContainer/components/EventWebinarUrl';
import { type Event } from 'hb-react/shared/apps/Events/types';
import EventDate from 'hb-react/shared/components/EventDate';
import useTimeZoneConfiguration from 'hb-react/shared/hooks/useTimeZoneConfiguration';

export const Card = ({ event }: { event: Event }) => {
  const {
    start_date: startDate,
    end_date: endDate,
    timezone,
    title,
    locations,
    webinar_url: webinarUrl,
    show_webinar_url: showWebinarUrl,
  } = event;
  const timezoneConfiguration = useTimeZoneConfiguration();
  const { currentUserTimezone, eventDatesInUserTimezone } =
    timezoneConfiguration;

  const eventDisplayTimeZone =
    eventDatesInUserTimezone && currentUserTimezone
      ? currentUserTimezone
      : timezone;

  return (
    <DSCard px={4}>
      <Box mb={6} alignItems="center">
        <Box alignSelf="center">
          <Calendar
            startDate={startDate}
            eventDisplayTimeZone={eventDisplayTimeZone}
          />
        </Box>
        <Box ml={4} font="h3-semibold" style={{ overflowWrap: 'anywhere' }}>
          {title}
        </Box>
      </Box>
      <Box>
        <Dotdotdot clamp={1}>
          <Box as="span" display="inline" fontWeight={2}>
            {__('Date:')}{' '}
          </Box>
          <EventDate
            as="span"
            event={{ start_date: startDate, end_date: endDate, timezone }}
            timezoneConfiguration={timezoneConfiguration}
          />
        </Dotdotdot>
      </Box>
      {locations?.address && (
        <Box mt={{ _: 2, m: 4 }}>
          <Dotdotdot clamp={1}>
            <Box as="span" display="inline" fontWeight={2}>
              {__('Location:')}{' '}
            </Box>{' '}
            {locations.address}
          </Dotdotdot>
        </Box>
      )}
      {webinarUrl && (
        <Box mt={{ _: 2, m: 4 }}>
          <Box
            as="span"
            display="inline"
            fontWeight={2}
            style={{ whiteSpace: 'nowrap' }}
          >
            {__('Online event')}
            {showWebinarUrl ? ':' : ''}
          </Box>
          <EventWebinarUrl
            webinar_url={webinarUrl}
            show_webinar_url={showWebinarUrl}
          />
        </Box>
      )}
    </DSCard>
  );
};
